// Typed accessor over the single-source-of-truth carrier list (src/data/carriers.json).
// The pure-Node build (../../carriers.data.mjs) and the middleware allowlist read the same JSON —
// keep functions/_middleware.js CARRIER_SLUGS in sync when the list changes.
import raw from './carriers.json'

export interface Carrier {
  slug: string
  name: string
  full: string
  scac: string
  hq: string
  source: 'connector' | 'official_api'
  coverage: string
  about: string
  description: string
}

export const CARRIERS = raw as Carrier[]

export const carrierBySlug = (slug: string): Carrier | undefined =>
  CARRIERS.find((c) => c.slug === slug)
